import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

export default new Echo({
  broadcaster: "reverb",
  key: "9e4084dffb65e6754b9565c38e8c8625", // Your actual REVERB_APP_KEY
  wsHost: "api.mehfil.aaibuzz.com", // WebSocket host (no port)
  wsPort: 6003, // WebSocket port for Reverb
  forceTLS: false,
  enabledTransports: ["ws"], // 👈 only ws
  disableStats: true,
  authEndpoint: "http://api.mehfil.aaibuzz.com/api/broadcasting/auth",
  auth: {
    headers: {
      // Dynamically get token on each auth request
      get Authorization() {
        const token = localStorage.getItem("token");
        return token ? `Bearer ${token}` : '';
      },
      Accept: "application/json",
    },
  },
});